module.exports = __webpack_public_path__ + "static/media/sendmessageActive.21f527de.svg";